<div class="min-vh-100 page-container">
  <ng-content></ng-content>
</div>

<jc-footer *ngIf="showFooter"></jc-footer>
